import { SuggestionSearchBar } from '@aibees/elephant/feature/suggestion-search-bar';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)``;

export const SearchBar = styled(SuggestionSearchBar)`
  &.compact {
    .childrenContainer {
      gap: 0;
      .SelectSearchType {
        .MuiInputBase-root {
          border-radius: 0;
          padding: ${(p) => p.theme.spacing(0.5, 0)};
        }
      }
      button {
        border-radius: ${(p) => p.theme.spacing(0, 1.5, 1.5, 0)};
      }
    }
    .top {
      gap: 0;
    }
  }
`;
